import React, { Component, useEffect, useRef } from 'react';
import { useState } from 'react';
import './ScentSelector.scss';
// import { growl } from '@crystallize/react-growl';
import { createPortal } from 'react-dom';

import ReactCardFlip from 'react-card-flip';
import ImageWithButton from './ImageWithButton';

const ScentSelectorModal = (props) => {
  const [readInfo, setReadInfo] = useState(false);

  const checkStockIsAvailable = (variant) => {
    // return true
    if (!variant?.quantity) {
      return false;
    }

    const data = props.scentsSelected[props.productType] || [];
    const currentCountInBasket = data?.reduce((acc, curr) => {
      if (curr === variant?.id) acc++;
      return acc;
    }, 0);
    return currentCountInBasket < Number(variant?.quantity);
  };

  const searchIsEmpty = (scents, searchValue) => {
    const allScents = Object.keys(scents)?.reduce((acc, key) => {
      acc = [...acc, ...scents[key]];
      return acc;
    }, []);

    const stringMatched = allScents.filter((scent) => {
      return scent.name.toLowerCase().includes(searchValue);
    })[0];

    return !stringMatched;
  };

  return (
    <>
      <div
        className={`scent-selector-wrapper ${props.isOpen ? 'is-open' : ''}`}
      >
        <div className="scent-selector-header">
          <div className="scent-selector-header__title">Select A Scent</div>
          <div
            className="scent-selector-header__close"
            onClick={() => props.setIsOpen(false)}
          >
            X
          </div>
        </div>
        <input
          placeholder="Search for a scent"
          value={props.searchValue}
          onChange={(e) =>
            props.setSearchValue(
              e.target.value !== '' ? e.target.value.toLowerCase() : ''
            )
          }
        />

        {props.searchValue !== '' ? (
          <>
            <button
              className="btn btn--block"
              onClick={() => props.setSearchValue('')}
            >
              Clear search results
            </button>
            <strong className="search-results-title">
              {searchIsEmpty(props.scents, props.searchValue)
                ? 'No Search Results Found'
                : 'Search Results'}
            </strong>

            <ul className="scentSelector__scent-list">
              {Object.keys(props.scents).map((key) =>
                props.scents[key].map(
                  (scent) =>
                  props.getVariant(scent.variants) && (
                    <li
                    className={
                      scent.name.toLowerCase().includes(props.searchValue)
                      ? ''
                      : 'is-hidden'
                    }
                    >
                        <ReactCardFlip isFlipped={readInfo === scent.name}>
                          <ImageWithButton
                            useOutline={true}
                            helpIcon={scent.description ? 'info' : false}
                            helpAction={() => setReadInfo(scent.name)}
                            imgUrl={scent.imgUrl}
                            ctaColor={
                              Number(
                                props.getVariant(scent.variants)?.quantity
                              ) <= 0 ||
                              !checkStockIsAvailable(
                                props.getVariant(scent.variants)
                              )
                                ? 'secondary'
                                : 'success'
                            }
                            ctaText={
                              Number(
                                props.getVariant(scent.variants)?.quantity
                              ) <= 0 ||
                              !checkStockIsAvailable(
                                props.getVariant(scent.variants)
                              )
                                ? 'Not In Stock'
                                : 'Select Scent'
                            }
                            ctaAction={
                              Number(
                                props.getVariant(scent.variants)?.quantity
                              ) <= 0 ||
                              !checkStockIsAvailable(
                                props.getVariant(scent.variants)
                              )
                                ? () => {}
                                : (e) =>
                                    props.setSelection(
                                      e,
                                      props.getVariant(scent.variants)
                                    )
                            }
                          />
                          <ImageWithButton
                            useOutline={true}
                            helpIcon="back"
                            helpAction={() => setReadInfo(false)}
                            imgUrl={scent.imgUrl}
                            textOverlay={scent.description}
                            titleOverlay={scent.name}
                            ctaColor={
                              Number(
                                props.getVariant(scent.variants)?.quantity
                              ) <= 0 ||
                              !checkStockIsAvailable(
                                props.getVariant(scent.variants)
                              )
                                ? 'secondary'
                                : 'success'
                            }
                            ctaText={
                              Number(
                                props.getVariant(scent.variants)?.quantity
                              ) <= 0 ||
                              !checkStockIsAvailable(
                                props.getVariant(scent.variants)
                              )
                                ? 'Not In Stock 2'
                                : 'Select Scent'
                            }
                            ctaAction={
                              Number(
                                props.getVariant(scent.variants)?.quantity
                              ) <= 0 ||
                              !checkStockIsAvailable(
                                props.getVariant(scent.variants)
                              )
                                ? () => {}
                                : (e) =>
                                    props.setSelection(
                                      e,
                                      props.getVariant(scent.variants)
                                    )
                            }
                          />
                        </ReactCardFlip>
                      </li>
                    )
                )
              )}
            </ul>
          </>
        ) : (
          <>
            <nav className="scentSelector__nav">
              <ul>
                {Object.keys(props.scents).map((key) => (
                  <li
                    className={
                      props.selectedScentCategory === key ? 'is-active' : ''
                    }
                    onClick={() => props.setSelectedScentCategory(key)}
                  >
                    {key.replace('Scents', '')}
                  </li>
                ))}
              </ul>
            </nav>

            <main className="scentSelector">
              {Object.keys(props.scents).map((key) => 
              
              (
                <ul
                  className="scentSelector__scent-list"
                  style={{
                    display:
                      props.selectedScentCategory === key ? 'flex' : 'none',
                  }}
                >
                  {props.scents[key].map((scent) => (
                                      props.getVariant(scent.variants) && (

                    <li>
                      <ReactCardFlip isFlipped={readInfo === scent.name}>
                        <ImageWithButton
                          useOutline={true}
                          helpIcon={scent.description ? 'info' : false}
                          helpAction={() => setReadInfo(scent.name)}
                          imgUrl={scent.imgUrl}
                          ctaColor={
                            Number(
                              props.getVariant(scent.variants)?.quantity
                            ) <= 0 ||
                            !checkStockIsAvailable(
                              props.getVariant(scent.variants)
                            )
                              ? 'secondary'
                              : 'success'
                          }
                          ctaText={
                            Number(
                              props.getVariant(scent.variants)?.quantity
                            ) <= 0 ||
                            !checkStockIsAvailable(
                              props.getVariant(scent.variants)
                            )
                              ? 'Not In Stock'
                              : 'Select Scent'
                          }
                          ctaAction={
                            Number(
                              props.getVariant(scent.variants)?.quantity
                            ) <= 0 ||
                            !checkStockIsAvailable(
                              props.getVariant(scent.variants)
                            )
                              ? () => {}
                              : (e) =>
                                  props.setSelection(
                                    e,
                                    props.getVariant(scent.variants)
                                  )
                          }
                        />

                        <ImageWithButton
                          useOutline={true}
                          helpIcon="back"
                          helpAction={() => setReadInfo(false)}
                          imgUrl={scent.imgUrl}
                          textOverlay={scent.description}
                          titleOverlay={scent.name}
                          ctaColor={
                            Number(
                              props.getVariant(scent.variants)?.quantity
                            ) <= 0 ||
                            !checkStockIsAvailable(
                              props.getVariant(scent.variants)
                            )
                              ? 'secondary'
                              : 'success'
                          }
                          ctaText={
                            Number(
                              props.getVariant(scent.variants)?.quantity
                            ) <= 0 ||
                            !checkStockIsAvailable(
                              props.getVariant(scent.variants)
                            )
                              ? 'Not In Stock'
                              : 'Select Scent'
                          }
                          ctaAction={
                            Number(
                              props.getVariant(scent.variants)?.quantity
                            ) <= 0 ||
                            !checkStockIsAvailable(
                              props.getVariant(scent.variants)
                            )
                              ? () => {}
                              : (e) =>
                                  props.setSelection(
                                    e,
                                    props.getVariant(scent.variants)
                                  )
                          }
                        />
                      </ReactCardFlip>
                    </li>
                  )))}
                </ul>
              ))}
            </main>
          </>
        )}
      </div>

      <div
        onClick={() => props.setIsOpen(false)}
        className={`scent-selector-backdrop ${
          !props.isOpen ? 'is-hidden' : ''
        }`}
      ></div>
    </>
  );
};

const ScentSelectorModalPortal = (props) => {
  const element = document.querySelector(`#scent-portal`);
  return createPortal(
    <ScentSelectorModal {...props} />,
    element
  );
};

const ScentSelector = (props) => {

  const [selectedScentCategory, setSelectedScentCategory] = useState(
    Object.keys(props.scents)[0]
  );
  const [scentsSelected, setScentsSelected] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const productId = props.product?.id;

  const getVariant = (variants, variantToChoose = props.size) => {
    return variants.filter((variant) => {
      return variant.name.includes(variantToChoose);
    })[0];
  };

  const getScentFromVariant = (providedVariant) => {
    if (!providedVariant) {
      return {};
    }
    return Object.keys(props.scents).reduce((acc, key) => {
      props.scents[key].forEach((scent) => {
        const foundVariant = scent.variants.filter((variant) => {
          return variant.id === providedVariant;
        })[0];
        if (foundVariant) {
          acc = scent;
        }
      });
      return acc;
    }, {});
  };

  const countScentsAdded = () => {
    if (!scentsSelected[props.productType]) {
      return 0;
    }
    return scentsSelected[props.productType].length;
  };

  window.removeProductSelections = () => {
    
    window.localStorage.removeItem(`selectedScents_${productId}`)

    setScentsSelected({});
  };

  useEffect(() => {    
    const currentlySelectedScents = JSON.parse(
      window.localStorage.getItem(`selectedScents_${productId}`)
    ) || {};

    setScentsSelected(currentlySelectedScents);
  }, []);

  useEffect(() => {
    if (document.querySelector('.scent-selector-overlay')) {
      if (countScentsAdded() < props.amountToSelect) { 
        document.querySelector('.scent-selector-overlay').style.zIndex = 100;
        if (document.getElementById('add-gift-set')) {
          document.getElementById('add-gift-set').style.display = 'none';
        }
      } else {
        document.querySelector('.scent-selector-overlay').style.zIndex = -10;
        if (document.getElementById('add-gift-set')) {
          document.getElementById('add-gift-set').style.display = 'block';
        }
      }
    }
  }, [scentsSelected]);

  const removeFromArray = (arr, index) => {
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };

  const setSelection = (e, variant, plusOrMinus = 'plus', i) => {
    e.preventDefault();
    const localData = JSON.parse(window.localStorage.getItem(`selectedScents_${productId}`));
    
    let currentlySelectedScents = localData ? localData[props.productType] : {};
    if (!currentlySelectedScents) {
      currentlySelectedScents = {}
    }
    let scentsSelectedBefore = scentsSelected[props.productType] || [];

    if (plusOrMinus === 'minus') {
      scentsSelectedBefore = removeFromArray(scentsSelectedBefore, i);
    } else if (countScentsAdded() < props.amountToSelect) {
      scentsSelectedBefore.push(variant?.id);
    }


    // if (currentlySelectedScents && currentlySelectedScents[props.productType]) {
    //   if (currentlySelectedScents[props.productType][productId]) {
    //     delete currentlySelectedScents[props.productType][productId];
    //   }
    // }

    const data = {
      ...localData,
      [props.productType]: [
        ...scentsSelectedBefore
      ]
    };

    setScentsSelected(data);
    setIsOpen(false);
    window.localStorage.setItem(`selectedScents_${productId}`, JSON.stringify(data));
  };

  const getSelectedScent = (number, scentsSelected) => {
    if (!scentsSelected[props.productType]) {
      return false;
    }
    if (!scentsSelected[props.productType][number]) {
      return false;
    }
    return getScentFromVariant(scentsSelected[props.productType][number]);
  };

  const selectScent = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  return (
    <section className="scentSelector">
      <div className="scents-selected">
        <div className="scents-selected__title">
          You have selected{' '}
          <strong>
            {countScentsAdded()} out of {props.amountToSelect}
          </strong>{' '}
          scents
        </div>

        <ul className="scents-selected__select">
          {[...Array(props.amountToSelect || [])].map((x, i) => (
            <li
              style={{
                opacity:
                  countScentsAdded() === 0 && i === 0
                    ? 1
                    : countScentsAdded() < i
                    ? 0.5
                    : 1,
              }}
            >
              <div className="image-count-wrapper">
                {getSelectedScent(i, scentsSelected) ? (
                  <>
                    <ImageWithButton
                      list={true}
                      titleOverlay={getSelectedScent(i, scentsSelected).name}
                      useOutline={true}
                      imgUrl={getSelectedScent(i, scentsSelected).imgUrl}
                      ctaColor="danger"
                      ctaText="Remove"
                      ctaAction={(e) =>
                        setSelection(
                          e,
                          getSelectedScent(i, scentsSelected),
                          'minus',
                          i
                        )
                      }
                    />

                    <input
                      type="hidden"
                      value={`${getSelectedScent(i, scentsSelected).name.replace('Soy Wax Melt', '').replace('Fragrance Oil', '').replace('Room Spray', '')} ${props.productType === 'Wax Melts' ? `/ ${props.size}` : ''}`}
                      name={`properties[${props.productType.replace('Fragrance Oil', 'FO').replace('Wax Melts', 'WM').replace('Room Sprays', 'RS')} Scent ${i + 1}]`}
                    />
                  </>
                ) : (
                  <ImageWithButton
                    list={true}
                    titleOverlay={'Choose your scent'}
                    imgUrl="https://cdn.shopify.com/s/files/1/0300/4966/5108/files/select-scent.png?v=1634401573"
                    ctaText="Select Scent"
                    imageCta={true}
                    ctaAction={selectScent}
                  />
                )}
              </div>
            </li>
          ))}
        </ul>
        
        {/* 
          <div className="scentSelector__footer">
            <Button className="btn" disabled={countScentsAdded() < props.amountToSelect}>Add to basket</Button>
          </div> */}
      </div>
      <ScentSelectorModalPortal
        scents={props.scents}
        setSearchValue={setSearchValue}
        productType={props.productType}
        searchValue={searchValue}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setSelectedScentCategory={setSelectedScentCategory}
        selectedScentCategory={selectedScentCategory}
        getVariant={getVariant}
        setSelection={setSelection}
        scentsSelected={scentsSelected}
      />
    </section>
  );
};

export default ScentSelector;
